@if (true) {
  <div>
    <input
      id="x"
      [value]="editorValue"
      type="hidden"
      />
      <trix-editor
        #textEditor
        input="x"
        class="trix-content"
      ></trix-editor>
    </div>
  }